import { Switch } from '@newfront-insurance/core-ui';

import {
  getCustomSkillDisplayText,
  getUpdatedLabel,
  hasUnpublishedChanges,
  type CustomSkillManagementTab,
} from './custom-skill-model';
import type { CustomSkillRecord } from '../../../../queries/chats';
import { SettingsListRow } from '../settings-list';

export function SettingsPageCustomSkillRow({
  skill,
  listScope,
  isPending,
  isExpanded,
  onOpen,
  onToggle,
  onToggleExpanded,
}: {
  skill: CustomSkillRecord;
  listScope: CustomSkillManagementTab;
  isPending: boolean;
  isExpanded: boolean;
  onOpen: () => void;
  onToggle: () => void;
  onToggleExpanded: () => void;
}) {
  const isSharedList = listScope === 'shared-with-me';
  const displayDescription = getCustomSkillDisplayText(skill.frontmatter.summary, skill.frontmatter.description);

  return (
    <SettingsListRow
      title={`/${skill.command}`}
      truncateTitle
      description={displayDescription}
      metadata={
        <>
          <span>
            {isSharedList ? 'Shared with you' : skill.enabled ? 'Enabled' : 'Disabled'}
            {' · '}Updated {getUpdatedLabel(skill.updatedAt)}
          </span>
          {hasUnpublishedChanges(skill) ? (
            <span className="rounded-[6px] bg-[#F4F8FE] px-2 py-1 text-[12px] leading-4 text-[#0957C3]">
              Unpublished changes
            </span>
          ) : null}
        </>
      }
      onClick={isSharedList ? onToggleExpanded : onOpen}
      isExpanded={isSharedList ? isExpanded : undefined}
      actionLabel={
        isSharedList && isExpanded
          ? `Collapse details for ${skill.frontmatter.name}`
          : `Open details for ${skill.frontmatter.name}`
      }
    >
      {isSharedList && isExpanded ? (
        <div className="border-t border-[#DEE2E7] bg-[#FAFBFC] px-4 py-3">
          <div className="flex flex-wrap items-center gap-3">
            <span className="text-[12px] leading-4 text-[#546A83]">{skill.enabled ? 'Enabled' : 'Disabled'}</span>
            <Switch enabled={skill.enabled} onClick={onToggle} locked={isPending} />
          </div>
        </div>
      ) : null}
    </SettingsListRow>
  );
}
